module.exports = __webpack_public_path__ + "static/media/androidBG.cc172e5b.jpg";